import { createRouter, createWebHistory } from 'vue-router'
import StudentList from './views/StudentList.vue'
import ClassSummary from './views/user/ClassSummary.vue'
import UserCenter from './views/user/UserCenter.vue'
import Balance from './views/user/Balance.vue'
import Recharge from './views/user/Recharge.vue'
import Points from './views/user/Points.vue'
import Cards from './views/user/Cards.vue'
import CardDetail from './views/user/CardDetail.vue'
import CompletedCards from './views/user/CompletedCards.vue'
import DistributionList from './views/user/DistributionList.vue'
import NetworkBinding from './views/user/NetworkBinding.vue'
import UserQuery from './views/user/UserQuery.vue'
import OrderStatistics from './views/user/OrderStatistics.vue'
import NetworkPerformance from './views/user/NetworkPerformance.vue'
import MyOrders from './views/user/MyOrders.vue'
import OrderDetail from './views/user/OrderDetail.vue'
import HomeLayout from './views/home/Index.vue'
import Order from './views/home/Order.vue'
import Payment from './views/home/Payment.vue'
import FacePurchase from './views/user/FacePurchase.vue'
import FaceCollection from './views/user/FaceCollection.vue'
import InspectionReport from './views/user/InspectionReport.vue'
import MilkNotice from './views/user/MilkNotice.vue'
import FaceRecognition from './views/user/FaceRecognition.vue'
import BindStudent from './views/user/BindStudent.vue'
import ProfileCompletion from './views/user/ProfileCompletion.vue'

const routes = [
  {
    path: '/',
    name: 'HomeLayout',
    component: HomeLayout,
    children: [
      { path: '', name: 'HomeIndex', component: HomeLayout },
    ]
  },
  { path: '/order', name: 'Order', component: Order },
  { path: '/payment', name: 'Payment', component: Payment },
  { path: '/students', name: 'StudentList', component: StudentList },
  { path: '/class-summary', name: 'ClassSummary', component: ClassSummary },
  { path: '/user', name: 'UserCenter', component: UserCenter },
  { path: '/balance', name: 'Balance', component: Balance },
  { path: '/recharge', name: 'Recharge', component: Recharge },
  { path: '/points', name: 'Points', component: Points },
  { path: '/cards', name: 'Cards', component: Cards },
  { path: '/card-detail', name: 'CardDetail', component: CardDetail },
  { path: '/completed-cards', name: 'CompletedCards', component: CompletedCards },
  { path: '/distribution-list', name: 'DistributionList', component: DistributionList },
  { path: '/network-binding', name: 'NetworkBinding', component: NetworkBinding },
  { path: '/user-query', name: 'UserQuery', component: UserQuery },
  { path: '/order-statistics', name: 'OrderStatistics', component: OrderStatistics },
  { path: '/network-performance', name: 'NetworkPerformance', component: NetworkPerformance },
  { path: '/my-orders', name: 'MyOrders', component: MyOrders },
  { path: '/order-detail', name: 'OrderDetail', component: OrderDetail },
  { path: '/face-purchase', name: 'FacePurchase', component: FacePurchase },
  { path: '/face-collection', name: 'FaceCollection', component: FaceCollection },
  { path: '/inspection-report', name: 'InspectionReport', component: InspectionReport },
  { path: '/milk-notice', name: 'MilkNotice', component: MilkNotice },
  { path: '/face-recognition', name: 'FaceRecognition', component: FaceRecognition },
  { path: '/bind-student', name: 'BindStudent', component: BindStudent },
  { path: '/profile-completion', name: 'ProfileCompletion', component: ProfileCompletion },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 